import React from 'react';
import PropTypes from 'prop-types';
import creditCardIcon from '../../../../../images/icons/cart/credit-card.svg';
import paypalIcon from '../../../../../images/icons/cart/paypal.svg';
import zipIcon from '../../../../../images/icons/cart/zip.svg';
import amazonPayIcon from '../../../../../images/icons/cart/amazon-pay.svg';
import styles from './PaymentMethods.module.sass';

function PaymentMethods(props) {
  const { showOnlyCreditCard } = props;

  return (
    <div className={styles.methods}>
      <div className={styles.method}>
        <img src={creditCardIcon} alt="Credit card" />
      </div>
      { !showOnlyCreditCard && (
        <>
          <div className={styles.method}>
            <img src={paypalIcon} alt="Paypal" />
          </div>
          <div className={styles.method}>
            <img src={zipIcon} alt="Zip" />
          </div>
          <div className={styles.method}>
            <img src={amazonPayIcon} alt="Amazon pay" />
          </div>
        </>
      )}
    </div>
  );
}

PaymentMethods.propTypes = {
  showOnlyCreditCard: PropTypes.bool.isRequired,
};

export default PaymentMethods;
